import { put, takeEvery, call } from "redux-saga/effects";

import * as apis from "../../network/apis/auth";
import {
  loginResponse,
  logoutResponse,
} from "./slice";
import { ROUTES_PATHS } from "../../utils/RoutesPaths";
import { clearAdmin, setAdminStorage, setDeviceId } from "../../utils/Auth";
import { showSnackMsg } from "../../utils/Helpers";

export function* loginSaga({ payload }) {
  try {
    const response = yield call(apis.login, payload.data);
    const device_id = payload.data.device_id;
    yield put(loginResponse(response.data?.admin));
    yield setAdminStorage(
      response.data?.admin,
      payload.data?.rememberMe ? "local" : "session"
    );
    yield setDeviceId(device_id);
    yield payload.navigate(ROUTES_PATHS.owners);
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export function* logoutSaga({ payload }) {
  try {
    yield call(apis.logout);
    yield put(logoutResponse());
    yield clearAdmin();
    yield payload.navigate(ROUTES_PATHS.login);
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}



export function* resetPasswordSaga({ payload }) {
  try {
    const response = yield call(apis.resetPassword, payload.data);
    yield showSnackMsg(payload.successMsg, "success");
    yield payload.navigate(ROUTES_PATHS.login);
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export default function* AuthSagas() {
  yield takeEvery("auth/loginRequest", loginSaga);
  yield takeEvery("auth/logoutRequest", logoutSaga);
  yield takeEvery("auth/resetPassword", resetPasswordSaga);
}
